<template>
  <path d="M7 14L12 9L17 14H7Z" />
</template>
